import { ArrayHelpers, useFormikContext } from 'formik';
import React, { CSSProperties, ReactElement } from 'react';
import { Activite, Client, Lieu } from '../../../../../common/src/entities';
import ClientLieu from '../../../../../common/src/entities/client-lieu.entity';
import LieuActivite from '../../../../../common/src/entities/lieu-activite.entity';
import { useAlertDialog } from '../../../Utils/dialogContext';
import ChampMultiple, { affichageElementDefaut } from '../../Common/ChampMultiple';
import { PopoutEntite } from '../Utils/PopoutEntite';
import CreerLieu from './CreerLieu';
import { affichageLieu } from './DetailsLieu';
import { cssTexte } from '../constantes';

interface PropsAffichageAjout {
    helpers: ArrayHelpers;
    values: LieuActivite[];
    avecUnBouton?: boolean;
    title?: string;
    maxSize?: number;
}

function AffichageAjout(props: PropsAffichageAjout): ReactElement {
    const bsAlert = useAlertDialog();
    const { values: activite } = useFormikContext<Activite>();
    return (
        <PopoutEntite
            titre={`Ajouter un ${props.title?.toLowerCase() ?? 'lieu'}`}
            entite={Lieu}
            isCreatable
            modalSize="lg"
            modalBody={(props) => <CreerLieu {...props} />}
            size="sm"
            onChange={(value) => {
                const lieu = value as Lieu;
                if (lieu) {
                    if (props.values.find((item) => item.lieu.id === lieu.id)) {
                        bsAlert('Ce lieu est déja associé!', 'warning');
                    } else {
                        //les fk sont requis pour l'enregistrement dans la bd
                        props.helpers.push({ lieu, fk_id_lieu: lieu.id, fk_id_activite: activite.id });
                    }
                } else {
                    alert();
                }
            }}
            avecUnBouton={props.avecUnBouton}
            getOptionLabel={(option) => affichageLieu(option)}
        />
    );
}

function AffichageTexte(props: { value: LieuActivite }): ReactElement {
    const {
        value: { lieu, detail },
    } = props;

    const lieuTexte: CSSProperties = {
        fontSize: '0.875rem',
    };

    return (
        <div style={lieuTexte}>
            <span>
                {lieu.name ? lieu.name + ' - ' : ''}
                {lieu.adresse ? lieu.adresse : ''}
                {lieu.ville ? ', ' + lieu.ville : ''}
                {lieu.province ? ', ' + lieu.province : ''}
                {lieu.code_postal ? ', ' + lieu.code_postal : ''}
            </span>
        </div>
    );
}

interface PropsAffichageDetail {
    value: LieuActivite;
}

function AffichageDetail(props: PropsAffichageDetail): ReactElement {
    return <div style={cssTexte}>{props.value.detail}</div>;
}

const affichageTexte = (value) => <AffichageTexte value={value} />;

export interface PropsChampMultipleLieuActivite {
    id: string;
    labelCol?: number;
    avecUnBouton?: boolean;
    details: (index: number) => string;
    suggestions: string[];
    maxSize?: number;
    title?: string;
    placeholder?: string;
    clickCrayon?: (index: number) => void;
}

export default function ChampMultipleLieuActivite(props: PropsChampMultipleLieuActivite): ReactElement {
    const affichageAjout = (values, helpers) => (
        <AffichageAjout helpers={helpers} values={values} avecUnBouton={props.avecUnBouton} />
    );
    return (
        <ChampMultiple
            entite={LieuActivite}
            titre={`${props.title ?? 'Lieux'}`}
            {...props}
            affichageAjout={affichageAjout}
            affichageElement={(value: LieuActivite | number, index: number, helpers: ArrayHelpers) => {
                return affichageElementDefaut(Lieu)((value as LieuActivite).lieu, index, helpers, () =>
                    affichageTexte(value),
                );
            }}
            clickCrayon={props.clickCrayon}
            reorderable
            AffichageDetail={(value) => <AffichageDetail value={value} />}
        />
    );
}
